import getConfig from 'next/config';
import { IWEBINAR_DATA } from '../../Utils/types';

export const SpeakerCard = ({
  webinarDetails,
}: {
  webinarDetails: IWEBINAR_DATA | null;
}) => {
  const { publicRuntimeConfig } = getConfig();

  return (
    <>
      <div className="text-s-24 font-bold sm:text-s-18 mt-4">
        About the Speaker
      </div>
      <div className="pb-4 flex items-center gap-4">
        {webinarDetails?.speaker?.image_link && (
          <div className="author-cirle">
            <img
              src={webinarDetails.speaker.image_link}
              width={86}
              height={86}
              alt="speaker-img"
            />
          </div>
        )}
        <div>
          <div className="text-s-20 text-font-500 font-bold sm:text-base">
            {webinarDetails?.speaker?.name}
          </div>
          <div className="text-base text-font-200 font-semibold sm:text-s-12">
            {webinarDetails?.speaker?.designation},{' '}
            {webinarDetails?.speaker?.company}
          </div>
        </div>
      </div>
      <p className="text-font-200 text-base font-medium mb-1">
        {webinarDetails?.speaker?.description}{' '}
      </p>
      <a
        href={`${publicRuntimeConfig.CLEARTAX_DOMAIN}/webinars/${webinarDetails?.slug}`}
        rel="noreferrer"
        className="text-blue-350 mx-6  font-bold text-base ml-0"
      >
        Know more →
      </a>
    </>
  );
};
